import React, { createContext, useContext, useState } from "react";
import ManagerApprovalModal from "./ManagerApprovalModal";
import DiscountApprovalModal from "./DiscountApprovalModal";
import ProductsPopup from "./ProductsPopup";
import CompanionPopup from "./CompanionPopup";
import db from "../../database";

import QRCodeModal from "./QRCodeModal";

// Event Bus Context
const EventBusContext = createContext();

// Event Bus Provider
const EventBusProvider = ({ children }) => {
  const [events, setEvents] = useState([]);
  const [isManagerApprovalModalVisible, setManagerApprovalModalVisible] = useState(false);
  const [approvalGrantedCallback, setApprovalGrantedCallback] = useState(null);

  const [isDiscountApproval, setIsDiscountApproval] = useState(false);
  const [discountApprovals, setDiscountApprovals] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [visibleProductsModal, setVisibleProductsModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const [itemSelectionCallback, setItemSelectionCallback] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedProductCallback, setSelectedProductCallback] = useState(null);
  const [weightPopup, setWeightPopup] = useState(false);
  const [productModalVisible, setProductModalVisible] = useState(false);
  const [inputFocused, setInputFocused] = useState(null);
  const [selectedProductInCart, setSelectedProductInCart] = useState({});
  const [isQRCodeModalVisible, setQRCodeModalVisible] = useState(false);
  const [qrCodeData, setQRCodeData] = useState(null);
  const [qrPaymentCallback, setQRPaymentCallback] = useState(null);
  const [qrPaymentMethod, setQRPaymentMethod] = useState(null);
  const [selectedCoupon, setSelectedCoupon] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [discountAmt, setDiscountAmt] = useState(0);
  const [totalSTD, setTotalSTD] = useState(0);
  const [popupCart, setPopupCart] = useState(null);
  const [popupSetCart, setPopupSetCart] = useState(() => {});
  const [popupSetProductStock, setPopupSetProductStock] = useState(() => {});

  const [companionPopupVisible, setCompanionPopupVisible] = useState(false);
  const [companionPopupProduct, setCompanionPopupProduct] = useState(null);
  const [companionAddCallback, setCompanionAddCallback] = useState(null);

  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;

  const dispatchEvent = (eventName, ruleName, ruleCondition, approvers, data, callback) => {
    const eventData = WorkflowEngine.processEvent({ name: eventName, ruleName, ruleCondition, data });
    const filteredApprovals = approvers.filter((res) => res.csBunitId === bunitId);
    setEvents([{ eventName, ruleName, ruleCondition, filteredApprovals }]);
    if (filteredApprovals.length > 0 && eventData?.managerApprovalRequired) {
      openManagerApprovalModalIfNeeded(eventData, callback);
    } else {
      callback({ approvalGranted: true });
    }
  };

  const discountApproval = (approvals, pricingRule, couponCode, discount, totalStd, callback) => {
    setEvents([{ approvals, callback }]);
    setSelectedCoupon(pricingRule);
    setCouponCode(couponCode);
    setDiscountAmt(discount);
    setTotalSTD(totalStd);
    setIsDiscountApproval(true);
    setDiscountApprovals(() => callback);
  };

  const dispatchQRCodeEvent = (qrCodeResponse, paymentMethod, callback) => {
    console.log("dispatchQRCodeEvent called", { qrCodeResponse });
    setQRCodeData(qrCodeResponse);
    setQRPaymentMethod(paymentMethod);
    setQRCodeModalVisible(true);
    setQRPaymentCallback(() => callback);
    console.log("QR code state updated", {
      qrCodeData: qrCodeResponse,
      qrPaymentMethod: paymentMethod,
      isQRCodeModalVisible: true,
      qrPaymentCallback: callback,
    });
  };

  const openManagerApprovalModalIfNeeded = (eventData, callback) => {
    if (eventData && eventData.managerApprovalRequired) {
      localStorage.setItem("approvalFlag", "0");
      setManagerApprovalModalVisible(true); // Open manager approval modal
      setApprovalGrantedCallback(() => callback);
    } else if (eventData && !eventData.managerApprovalRequired) {
    }
  };

  // Function to close the manager approval modal
  const closeManagerApprovalModal = () => {
    localStorage.setItem("approvalFlag", "1");
    setManagerApprovalModalVisible(false);
  };

  const handleApprovalGranted = (data) => {
    closeManagerApprovalModal();
    // Simulate approval
    const approvalGranted = data;
    const eventData = { approvalGranted };
    if (approvalGranted && approvalGrantedCallback) {
      approvalGrantedCallback(eventData);
    }
  };

  const handleDiscountApproval = (data) => {
    closeDiscountApproval();
    const approvalGranted = data;
    const eventData = { approvalGranted };
    discountApprovals(eventData);
  };

  const closeDiscountApproval = () => {
    setIsDiscountApproval(false);
  };

  const closeQRCodeModal = () => {
    setQRCodeModalVisible(false);
    setQRPaymentMethod(null);
    setQRCodeData(null);
    qrPaymentCallback(null);
    console.log("QR code modal closed", { isQRCodeModalVisible: false, qrCodeData: null });
  };

  const dispatchItemSelection = async (selecTedItem, cart, setCart, setProductStock, setShowCompleteSaleStock, setCompleteSaleStockData, callback) => {
    if (selecTedItem?.companion === "Y") {
      setCompanionPopupProduct(selecTedItem);
      setCompanionAddCallback(() => callback);
      setPopupCart(cart);
      setPopupSetCart(() => setCart);
      setPopupSetProductStock(() => setProductStock);
      setCompanionPopupVisible(true);
    } else {
      const items = selecTedItem?.childItems || [];
      setSelectedProduct(selecTedItem);
      setVisibleProductsModal(true);
      setSelectedItems(items);
      setProductModalVisible(true);
      setItemSelectionCallback(() => callback);

      setPopupCart(cart);
      setPopupSetCart(() => setCart);
      setPopupSetProductStock(() => setProductStock);

      const productsList = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.productSegment !== "BG")
        .toArray();

      // Separate matched and unmatched products
      const matchedProducts = [];
      const remainingProducts = [];

      productsList.forEach((item) => {
        const selectedItem = items.find((selected) => selected.productId === item.productId);
        if (selectedItem) {
          matchedProducts.push({ ...item, weight: selectedItem.weight });
        } else {
          remainingProducts.push(item);
        }
      });

      // Combine matched products first, then the remaining products
      const updatedProductsList = [...matchedProducts, ...remainingProducts];

      setProductData(updatedProductsList);
    }
  };

  const onSubmit = () => {
    const eventData = { selectedItems };
    console.log("eventData -------->", eventData);
    itemSelectionCallback(eventData);
  };

  const dispatchWeight = (product, setInputFocused, selectedProductInCart, setSelectedProductInCart, callback) => {
    setSelectedProduct(product);
    setWeightPopup(true);
    setInputFocused(() => setInputFocused);
    setProductModalVisible(true);
    setSelectedProductCallback(() => callback);
    setSelectedProductInCart(() => callback);
  };

  const closeCompanionPopup = () => {
    setCompanionPopupVisible(false);
    setCompanionPopupProduct(null);
    setCompanionAddCallback(null);
  };

  const handleCompanionAdd = (headerProduct, companionProduct) => {
    if (!companionAddCallback) return;
    const selectedItems = companionProduct ? [companionProduct] : [];
    selectedItems[0].name = companionProduct?.companion_product_name;
    selectedItems[0].productId = companionProduct?.companion_product_id;
    selectedItems[0].lineId = companionProduct?.line_id;
    selectedItems[0].weight = 0;
    selectedItems[0].discount = 0;
    selectedItems[0].taxAmount = 0;
    selectedItems[0].realPrice = 0;
    selectedItems[0].nettotal = 0;
    companionAddCallback({ selectedItems });
    closeCompanionPopup();
  };

  return (
    <EventBusContext.Provider value={{ dispatchEvent, events, discountApproval, dispatchItemSelection, dispatchQRCodeEvent, closeQRCodeModal, dispatchWeight }}>
      {children}
      <CompanionPopup visible={companionPopupVisible} onClose={closeCompanionPopup} selectedProduct={companionPopupProduct} onAddToCart={handleCompanionAdd} />
      {isManagerApprovalModalVisible && (
        <ManagerApprovalModal
          event={events}
          onClose={closeManagerApprovalModal}
          visible={isManagerApprovalModalVisible}
          setManagerApprovalModalVisible={setManagerApprovalModalVisible}
          onApprovalGranted={handleApprovalGranted}
        />
      )}
      {isDiscountApproval && (
        <DiscountApprovalModal
          event={events}
          onClose={closeDiscountApproval}
          visible={isDiscountApproval}
          setIsDiscountApproval={setIsDiscountApproval}
          onApprovalGranted={handleDiscountApproval}
          selectedCoupon={selectedCoupon}
          setSelectedCoupon={setSelectedCoupon}
          couponCode={couponCode}
          discountAmt={discountAmt}
          totalSTD={totalSTD}
        />
      )}
      {productModalVisible && (
        <ProductsPopup
          productData={productData}
          event={events}
          visibleProductsModal={visibleProductsModal}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          dispatchItemSelection={dispatchItemSelection}
          setVisibleProductsModal={setVisibleProductsModal}
          onSubmit={onSubmit}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          selectedProductCallback={selectedProductCallback}
          weightPopup={weightPopup}
          setWeightPopup={setWeightPopup}
          inputFocused={inputFocused}
          selectedProductInCart={selectedProductInCart}
          setSelectedProductInCart={setSelectedProductInCart}
          cart={popupCart}
          setCart={popupSetCart}
          setProductStock={popupSetProductStock}
        />
      )}
      {isQRCodeModalVisible && (
        <QRCodeModal
          qrCodeData={qrCodeData}
          paymentMethod={qrPaymentMethod}
          visible={isQRCodeModalVisible}
          onClose={closeQRCodeModal}
          qrPaymentCallback={qrPaymentCallback}
          setQRCodeModalVisible={setQRCodeModalVisible}
        />
      )}
    </EventBusContext.Provider>
  );
};

// Use this hook to access the event bus
const useEventBus = () => useContext(EventBusContext);

// Workflow Engine
const WorkflowEngine = {
  processEvent: (eventWithRules) => {
    const rule = eventWithRules.ruleName;
    const data = eventWithRules.data;
    const actions = JSON.parse(eventWithRules.ruleCondition).conditions[0].actions;
    switch (rule) {
      case "Draft Print Receipt Approval":
        console.log(JSON.parse(eventWithRules.ruleCondition));
        if (actions[0].actionType === "requestApprovalForDraftPrint") {
          localStorage.setItem("approvalFlag", "0");
          return { managerApprovalRequired: true, actions };
        }
      case "Sales Return Approval":
        // const actions = JSON.parse(eventWithRules.ruleCondition).conditions[0].actions;
        console.log(JSON.parse(eventWithRules.ruleCondition));
        if (actions[0].actionType === "requestApprovalForReturn") {
          return { managerApprovalRequired: true, actions };
        }
      case "Cancel KOT":
        // const actions = JSON.parse(eventWithRules.ruleCondition).conditions[0].actions;
        console.log(JSON.parse(eventWithRules.ruleCondition));
        if (actions[0].actionType === "requestApprovalForCancelKOT") {
          return { managerApprovalRequired: true, actions };
        }
      case "Coupon Approval":
        console.log("Coupon Approval", JSON.parse(eventWithRules.ruleCondition));
        if (actions[0].actionType === "requestApprovalForCoupon") {
          return { managerApprovalRequired: true, actions };
        }
      case "Receipt Reprint Approval":
        // const actions = JSON.parse(eventWithRules.ruleCondition).conditions[0].actions;
        console.log(JSON.parse(eventWithRules.ruleCondition));
        if (actions[0].actionType === "requestApprovalForReprint") {
          return { managerApprovalRequired: true, actions };
        }
      case "Cancel Parked Bill Approval":
        // const actions = JSON.parse(eventWithRules.ruleCondition).conditions[0].actions;
        console.log(JSON.parse(eventWithRules.ruleCondition));
        if (actions[0].actionType === "requestApprovalForCancelParkedBill") {
          return { managerApprovalRequired: true, actions };
        }
      case "Cash Management Request":
        // const actions = JSON.parse(eventWithRules.ruleCondition).conditions[0].actions;
        const criteria = JSON.parse(eventWithRules?.ruleCondition)?.conditions[0].criteria;
        console.log(JSON.parse(eventWithRules.ruleCondition));
        if (actions[0].actionType === "requestApprovalForCashManagement" && Number(criteria[0]?.value) < Number(data?.amount)) {
          return { managerApprovalRequired: true, actions };
        } else {
          return { managerApprovalRequired: false, actions };
        }
        break;
      default:
        return { approvalGranted: true };
    }
  },
};

export { EventBusProvider, useEventBus };
